import { useMutation, useQueryClient } from "@tanstack/react-query";
import { companyQueryKeys } from "service/crm/api/company";
import { contactQueryKeys } from "service/crm/api/contact";
import { dealApi, dealQueryKeys } from "service/crm/api/deal";
import { DealDetail, UpdateDealAssociationsPayload } from "types/crm/deal";

export const useUpdateDealAssociationsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      payload: UpdateDealAssociationsPayload,
    ): Promise<DealDetail> => dealApi.updateDealAssociations(payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: dealQueryKeys.detail(variables.dealUuid),
      });
      queryClient.invalidateQueries({
        queryKey: contactQueryKeys.byDeal(variables.dealUuid),
      });
      queryClient.invalidateQueries({
        queryKey: companyQueryKeys.byDeal(variables.dealUuid),
      });
      queryClient.invalidateQueries({
        queryKey: dealQueryKeys.activities(variables.dealUuid),
      });
    },
  });
};
